import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-visible-icon',
  templateUrl: './general-visible.component.html'
})
export class GeneralVisibleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
